import MuiTableFooter, { TableFooterProps } from '@material-ui/core/TableFooter';

export type DSTableFooterProps = TableFooterProps;

export const DSTableFooter = MuiTableFooter;
